/* src/app/modules/print-cards/components/card-grid/card-grid.component.scss */
:host {
  position: relative;
}
/*# sourceMappingURL=card-grid.component.css.map */
